import TabPage from "./../factories/tab-page";
import BaseViewModelModule from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import BaoDialog from "./../factories/bao-dialog";
class ActivityType extends BaseViewModelModule {
    MandatorId: KnockoutObservable<string> = ko.observable("");
    MandatorNumberName: KnockoutObservable<string> = ko.observable("");
    MandatorEnabled: KnockoutObservable<boolean> = ko.observable(false);
    AllMandators: KnockoutObservable<boolean> = ko.observable(false);
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.subscribe(this.AllMandators, this.AllMandators_Changed);
    }
    AllMandators_Changed = () => {
        if (this.AllMandators() == true) {
            this.MandatorId("");
            this.MandatorNumberName("");
        }
    };
    //ConfigurationItemTypeTab: Factories.TabPage;
    //ConfigurationItemTypeTabTitle = ko.observable<string>();     
    //TabController = new TabController(false);
    CompleteCheck() {
        var isComplete: boolean = true;
        if (this.AllMandators() == false && Bao.Utils.String.IsNullOrEmpty(this.MandatorId())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitUrl() {
        return "ActivityType/Init";
    }
    loaded() {
        super.loaded();
        //this.ConfigurationItemTypeTab = new TabPage();
        //this.ConfigurationItemTypeTab.Url("ActivityType/ConfigurationItemTypeTab");
        //this.TabController.AddTab(this.ConfigurationItemTypeTab);
    }
}
export default ActivityType;